import { JSX } from 'react'

import { IconProps } from '../../icon'

const Globalizado: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M24.5 8.47522C15.9259 8.47522 8.97522 15.4259 8.97522 24C8.97522 32.5741 15.9259 39.5247 24.5 39.5247C33.0741 39.5247 40.0247 32.5741 40.0247 24C40.0247 15.4259 33.0741 8.47522 24.5 8.47522ZM24.5 29.5838C21.4159 29.5838 18.9155 27.084 18.9155 24C18.9155 20.9159 21.4159 18.4161 24.5 18.4161C27.584 18.4161 30.0838 20.9159 30.0838 24C30.0838 27.084 27.584 29.5838 24.5 29.5838Z'
      fill='#53BCE9'
    />
    <path
      d='M24.4999 29.5838V39.5247C20.2126 39.5247 16.332 37.7872 13.5223 34.9775L20.5516 27.9483C21.5623 28.959 22.9576 29.5838 24.4999 29.5838Z'
      fill='#47C97F'
    />
    <path
      d='M13.5224 13.0224L20.5516 20.0516C19.5409 21.0617 18.9161 22.4583 18.9161 24H8.97522C8.97522 19.7133 10.7127 15.8314 13.5224 13.0224Z'
      fill='#36A6CE'
    />
    <path
      d='M35.4776 13.0224L28.4484 20.0516C27.4377 19.0409 26.0423 18.4161 24.5 18.4161V8.47522C28.7874 8.47522 32.6679 10.2127 35.4776 13.0224Z'
      fill='#FA3F68'
    />
    <path
      d='M30.0838 24H40.0248C40.0248 28.2867 38.2873 32.1686 35.4776 34.9776L28.4484 27.9484C29.4591 26.9383 30.0838 25.5417 30.0838 24Z'
      fill='#E29A4B'
    />
    <path
      d='M28.4484 27.9483L35.4776 34.9775C32.6679 37.7872 28.7874 39.5247 24.5 39.5247V29.5838C26.0423 29.5838 27.4377 28.959 28.4484 27.9483Z'
      fill='#FCB65F'
    />
    <path
      d='M40.0248 24H30.0838C30.0838 22.4583 29.4591 21.0617 28.4484 20.0516L35.4776 13.0224C38.2873 15.8314 40.0248 19.7133 40.0248 24Z'
      fill='#E02F5E'
    />
    <path
      d='M18.9161 24C18.9161 25.5417 19.5409 26.9383 20.5516 27.9484L13.5224 34.9776C10.7127 32.1686 8.97522 28.2867 8.97522 24H18.9161Z'
      fill='#35B568'
    />
    <path
      d='M39.1692 17.6016L38.2982 17.982C39.0655 19.7387 39.4824 21.6011 39.5414 23.5248H30.5405C30.4381 22.2107 29.9145 21.0132 29.1051 20.067L35.4707 13.7014C36.1894 14.4666 36.8305 15.3056 37.3771 16.2066L38.1897 15.7137C36.7885 13.4036 34.8106 11.4704 32.4698 10.1232C30.0564 8.73416 27.3005 8 24.5 8C20.2263 8 16.2083 9.66432 13.1863 12.6863C10.1643 15.7083 8.5 19.7263 8.5 24C8.5 28.2737 10.1643 32.2917 13.1863 35.3137C16.2083 38.3357 20.2263 40 24.5 40C28.7737 40 32.7917 38.3357 35.8137 35.3137C38.8357 32.2917 40.5 28.2737 40.5 24C40.5 21.7761 40.0523 19.6234 39.1692 17.6016ZM16.1763 32.3237C15.9907 32.1381 15.6899 32.138 15.5042 32.3237L13.5281 34.2998C11.0037 31.6147 9.57222 28.1589 9.45867 24.4752H18.4588C18.5613 25.7894 19.085 26.987 19.8946 27.9333L16.6447 31.1831L17.3168 31.8552L20.5667 28.6053C21.5131 29.4145 22.7106 29.9381 24.0247 30.0405V39.0412C20.3411 38.9277 16.8852 37.4962 14.2002 34.9718L16.1763 32.9957C16.3619 32.8102 16.3619 32.5093 16.1763 32.3237ZM24.0248 17.9595C22.7107 18.0619 21.5131 18.5854 20.5668 19.3947L14.2002 13.0281C16.8853 10.5037 20.3411 9.07222 24.0248 8.95867V17.9595ZM19.8946 20.0667C19.0851 21.013 18.5613 22.2106 18.4589 23.5248H9.45867C9.57222 19.8411 11.0037 16.3853 13.5281 13.7002L19.8946 20.0667ZM24.9752 30.0405C26.2892 29.9381 27.4868 29.4145 28.433 28.6051L34.7998 34.9719C32.1148 37.4963 28.6589 38.9278 24.9752 39.0413V30.0405ZM29.1051 27.9331C29.9145 26.9868 30.4381 25.7893 30.5406 24.4752H39.5413C39.4278 28.1589 37.9963 31.6147 35.4719 34.2998L29.1051 27.9331ZM24.5 29.1086C21.6827 29.1086 19.3908 26.8169 19.3908 24C19.3908 21.1831 21.6827 18.8914 24.5 18.8914C27.3169 18.8914 29.6086 21.1831 29.6086 24C29.6086 26.8169 27.3169 29.1086 24.5 29.1086ZM34.7985 13.0293L28.433 19.3949C27.4868 18.5855 26.2893 18.0619 24.9752 17.9595V8.95816C27.4453 9.03604 29.8629 9.71951 31.9957 10.947C33.0093 11.5303 33.9493 12.2316 34.7985 13.0293Z'
      fill='black'
    />
  </svg>
)

export default Globalizado
